module.exports = __webpack_public_path__ + "static/media/toast-success.390528e8.svg";